export class Alert {
    id: string;
    type: AlertType;
    message: string;
    autoClose: number = 5000;
    keepAfterRouteChange: boolean = false;
    fade: boolean;

    constructor(init?:Partial<Alert>) {
        Object.assign(this, init);
    }
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}